import { FC, SVGProps } from 'react';

export const ScaleDownIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M26.75 13.9857C26.7477 14.4 26.4101 14.7339 25.9959 14.7316L17.9959 14.6877C17.5833 14.6855 17.25 14.3503 17.25 13.9377L17.25 5.99999C17.25 5.58577 17.5858 5.24999 18 5.24999C18.4142 5.24999 18.75 5.58577 18.75 5.99999L18.75 13.1918L26.0041 13.2316C26.4183 13.2339 26.7523 13.5715 26.75 13.9857Z"
			fill="currentColor"
		/>
		<path
			d="M6.00001 17.7459C6.00228 17.3317 6.33991 16.9977 6.75412 17L14.7541 17.0439C15.1667 17.0462 15.5 17.3813 15.5 17.7939L15.5 25.7316C15.5 26.1459 15.1642 26.4816 14.75 26.4816C14.3358 26.4816 14 26.1459 14 25.7316V18.5398L6.74588 18.5C6.33168 18.4977 5.99774 18.1601 6.00001 17.7459Z"
			fill="currentColor"
		/>
	</svg>
);
